import { Card } from "react-bootstrap";

export const ContactMapPlaceholder = ({ numberOfCards = 1 }) => {
  return (
    <>
      {Array.from({ length: numberOfCards }).map((_, index) => (
        <div className="col-md-6">
          <div className="contact_map_block">
            <Card className="contact_map_card placeholder-card">
              <Card.Body>
                <div className="contact_head_block">
                  <div className="contact_initial_block placeholder-circle"></div>
                  <div className="contact_map_name_block">
                    <p className="contact_map_name">
                      <span className="placeholder " style={{"width": '150px'}}>  </span>
                    </p>
                  </div>
                </div>
                <div className="contact_map_info_block">
                  <p className="contact_map_designation placeholder-line"></p>
                  <p className="contact_map_details placeholder-line short"></p>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      ))}
    </>
  );
};
